import * as activateActions from "./activate.actions";
import { Action, createReducer, on } from "@ngrx/store";
import { MobileActivate } from "./activate.state";

const initialState: MobileActivate = {
	cart: null,
	internationalMinutes: null,
	mobilePlanSelectionState: null,
	plansWithContent: null,
	promoDetails: null,
	sale: null,
	validation: null,
	product: null,
	simNumber: null,
};

const featureReducer = createReducer(
	null,
	on(activateActions.setActivate, (state, { payload }) => {
		const {
			cart,
			internationalMinutes,
			mobilePlanSelectionState,
			plansWithContent,
			promoDetails,
			sale,
		} = payload;
		return {
			...state,
			cart,
			internationalMinutes,
			mobilePlanSelectionState,
			plansWithContent,
			promoDetails,
			sale,
		};
	}),
	on(
		activateActions.setMobilValidationActivate,
		(state, { validation, simNumber }) => {
			return {
				...state,
				validation,
				simNumber,
			};
		}
	),
	on(
		activateActions.setMobileCustomerEmail,
		(state, { validation, email }) => {
			const customerDetails = validation?.customerDetails;
			return {
				...state,
				validation: {
					...validation,
					customerDetails: {
						...customerDetails,
						email,
					},
				},
			};
		}
	),
	on(activateActions.setSimActivate, (state, { activate }) => {
		return {
			...activate,
		};
	}),
	on(activateActions.resetActivate, () => null)
);

export function mobileActivateReducer(
	state: MobileActivate | undefined,
	action: Action
): MobileActivate | undefined {
	return featureReducer(state, action);
}
